// This file should reflect what is in Tax.rb

import {Decimal} from 'decimal.js'

// Configure Decimal rounding if needed (default is ROUND_HALF_UP, standard for currency)
Decimal.set({precision: 20, rounding: Decimal.ROUND_HALF_UP})

const EXCLUSIVE = 'EXCLUSIVE'
const INCLUSIVE = 'INCLUSIVE'
const NONE = 'NONE'

export const TAX_TYPES = {
  exclusive: EXCLUSIVE,
  inclusive: INCLUSIVE,
  none: NONE
}

// Helper to round to 2 decimal places safely
const round = num => new Decimal(num).toDecimalPlaces(2, Decimal.ROUND_HALF_UP)

export const calculateLineItems = (lineItems = [], taxType) => {
  return lineItems.map(lineItem => {
    const quantity = new Decimal(lineItem.quantity ?? 0)

    // Determine the input unitPrice safely
    let unitPrice
    if (lineItem.unitPrice !== undefined && lineItem.unitPrice !== null && lineItem.unitPrice !== '') {
      unitPrice = new Decimal(lineItem.unitPrice)
    } else {
      // Fallback to server-provided exclusive property
      const unitPriceExclGst = new Decimal(lineItem.unitPriceExclGst ?? 0)
      // Convert the server's exclusive price back to the inclusive price for the input box
      unitPrice = taxType === INCLUSIVE ? round(unitPriceExclGst.times(1.15)) : unitPriceExclGst
    }

    let unitPriceExclGst = new Decimal(0)
    let totalGst = new Decimal(0)
    let totalAmount = new Decimal(0)

    switch (taxType) {
      case INCLUSIVE: {
        unitPriceExclGst = round(unitPrice.dividedBy(1.15))
        totalAmount = round(unitPrice.times(quantity))
        totalGst = round(totalAmount.times(3).dividedBy(23))
        break
      }
      case EXCLUSIVE: {
        unitPriceExclGst = round(unitPrice)
        const lineTotalExcl = unitPriceExclGst.times(quantity)
        totalGst = round(lineTotalExcl.times(0.15))
        totalAmount = round(lineTotalExcl.plus(totalGst))
        break
      }
      case NONE:
      default: {
        unitPriceExclGst = round(unitPrice)
        totalGst = new Decimal(0)
        totalAmount = round(unitPriceExclGst.times(quantity))
        break
      }
    }

    return {
      ...lineItem,
      quantity: quantity.toNumber(),
      unitPrice: unitPrice.toNumber(),
      unitPriceExclGst: unitPriceExclGst.toNumber(),
      totalGst: totalGst.toNumber(),
      totalAmount: totalAmount.toNumber()
    }
  })
}

export const calculateTotals = (lineItems = [], taxType) => {
  // Subtotal (Sum of exclusive line totals)
  const subtotal = round(
    lineItems.reduce(
      (sum, item) => sum.plus(new Decimal(item.unitPrice ?? 0).times(item.quantity ?? 0)),
      new Decimal(0)
    )
  )

  // Tax (Sum of all line GST amounts, or 0 if tax is NONE)
  const tax =
    taxType === NONE
      ? new Decimal(0)
      : round(lineItems.reduce((sum, item) => sum.plus(item.totalGst ?? 0), new Decimal(0)))

  // Grand Total (Sum of all final line amounts)
  const total = round(lineItems.reduce((sum, item) => sum.plus(item.totalAmount ?? 0), new Decimal(0)))

  return {
    subtotal: subtotal.toNumber(),
    tax: tax.toNumber(),
    total: total.toNumber()
  }
}
